export const GET_YARN_REQUEST = 'GET_YARN_REQUEST';
export const GET_YARN_DATA = 'GET_YARN_DATA';
export const GET_YARN_ERROR = 'GET_YARN_ERROR';

export const CREATE_YARN_REQUEST = 'CREATE_YARN_REQUEST';
export const CREATE_YARN_DATA = 'CREATE_YARN_DATA';
export const CREATE_YARN_ERROR = 'CREATE_YARN_ERROR';

export const UPDATE_YARN_REQUEST = 'UPDATE_YARN_REQUEST';
export const UPDATE_YARN_DATA = 'UPDATE_YARN_DATA';
export const UPDATE_YARN_ERROR = 'UPDATE_YARN_ERROR';

export const DELETE_YARN_REQUEST = 'DELETE_YARN_REQUEST';
export const DELETE_YARN_DATA = 'DELETE_YARN_DATA';
export const DELETE_YARN_ERROR = 'DELETE_YARN_ERROR';
